import { Prices } from '../../../lib/getPrices'
import { libraryFunctions } from '../../../lib/resources/price'
import { getSalesUnit } from '../../../lib/salesUnit'
import { getProductName } from '../../../lib/text'
import { Product } from '../../../utils/types/Product'

const { getDefaultPrice } = libraryFunctions

interface SingleProductModel {
  product: Product

  isRouterReady?: boolean

  handleAddToCart?: () => void

  openRFQModal?: () => void

  openSampleRequestModal?: () => void

  openDocumentRequestModal?: () => void

  orderInfo?: Partial<{
    [productCode: string]: {
      defaultPriceTotal: number
      finalPrice: number
      finalPriceTotal: number
      finalPriceWeighted: number
    }
  }>

  priceSection?: Partial<{
    usingPrice: Prices
  }>

  productColumn?: Partial<{
    deliveryEstimation: string
  }>
}

class SingleProduct implements SingleProductModel {
  product: SingleProductModel['product']

  isRouterReady: SingleProductModel['isRouterReady']

  handleAddToCart: SingleProductModel['handleAddToCart']

  openRFQModal: SingleProductModel['openRFQModal']

  openSampleRequestModal: SingleProductModel['openSampleRequestModal']

  openDocumentRequestModal: SingleProductModel['openDocumentRequestModal']

  orderInfo: SingleProductModel['orderInfo']

  priceSection: SingleProductModel['priceSection']

  productColumn: SingleProductModel['productColumn']

  constructor(model: SingleProductModel) {
    const {
      product,
      isRouterReady,
      handleAddToCart,
      openRFQModal,
      openSampleRequestModal,
      openDocumentRequestModal,
      orderInfo,
      priceSection,
      productColumn,
    } = model

    this.product = product
    this.isRouterReady = isRouterReady
    this.handleAddToCart = handleAddToCart
    this.openRFQModal = openRFQModal
    this.openSampleRequestModal = openSampleRequestModal
    this.openDocumentRequestModal = openDocumentRequestModal
    this.orderInfo = orderInfo
    this.priceSection = priceSection
    this.productColumn = productColumn

    this.getProductName = this.getProductName.bind(this)
    this.getSalesUnit = this.getSalesUnit.bind(this)
    this.getProductMoq = this.getProductMoq.bind(this)
  }

  getProductName() {
    return getProductName(this.product)
  }

  getSalesUnit() {
    return getSalesUnit(this.product)
  }

  getProductMoq() {
    return getDefaultPrice(this.product.price)?.['price.quantity'] || 1
  }

  getProductPrice() {
    return getDefaultPrice(this.product.price)?.['price.value'] || 0
  }
}

export default SingleProduct
